<template>
  <div id="delete-resource-modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <span class="uk-modal-title heading">{{heading}}</span>
      <p class="message">{{$t('modals.delete.unrecoverable')}}</p>
      <p class="uk-text-right" style="margin-top: 56px">
        <button class="cancel-button add-pointer uk-modal-close uk-text-capitalize">{{$t('general.cancel')}}</button>
        <button class="delete-button add-pointer uk-modal-close uk-text-capitalize" @click="deleteTrigger">{{$t('general.delete')}}</button>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'delete-modal',
    props: ['heading'],
    methods: {
      deleteTrigger() {
        this.$emit('delete-resource')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours';

  .heading {
    font-size: 24px;
    font-weight: bold;
    margin-left: 32px;
    margin-top: 32px;
    color: $content-text;
  }

  .message {
    margin-left: 32px;
    margin-top: 32px;
    font-size: 22px;
    color: $content-text;
  }

  .cancel-button {
    width: 238px;
    height: 44px;
    margin-right: 24px;
    border-radius: 2px;
    background-color: $lightest-gray;
    border: solid 2px $text-area-background;
    font-size: 18px;
    font-weight: bold;
    color: $text-area-background;

    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
      color: $nepal;
    }
  }

  .delete-button {
    width: 238px;
    height: 44px;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    border: solid 2.8px $input-warning;
    background-color: $input-warning;
    font-size: 18px;
    font-weight: bold;
    color: white;

    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
      color: $input-warning;
    }
  }

  .uk-modal-dialog {
    width: 900px;
    height: 252px;
    border-radius: 2.8px;
    box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    background-color: $lightest-gray;
  }
</style>
